import { gql } from '@apollo/client';

export const ALL_PRODUCTS_QUERY_NAME = 'AllProducts';
export const ALL_PRODUCTS = gql`
    query ${ALL_PRODUCTS_QUERY_NAME}(
        $page: Int, 
        $perPage: Int, 
        $includeDeactivated: Boolean,
        $sortKey: String,
        $sortDirection: String,
        $valueMapping: Map_String_List_MappedValueScalar,
        $productTypeFilter: ProductTypeFilter!
    ) {
        allProducts(
            page: $page, 
            perPage: $perPage, 
            includeDeactivated: $includeDeactivated,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
            valueMapping: $valueMapping,
            productTypeFilter: $productTypeFilter
        ) {
            availableDeliveryTypes
            availableDeliveryPeriods
            availableQuantityUnits
            availableProductTypes
            productList {
                totalCount
                models {
                    id
                    active
                    productType
                    name
                    productId
                    isinCode
                    iconSymbol
                    iconColor
                    deliveryType
                    deliveryPeriod
                    quantityUnit
                    deactivationBlockers
                    modificationBlockers {
                        blockerConstants
                        nonModifiableFields
                    }
                }
            }
        }
    }
`;

export const CREATE_PRODUCT = gql`
    mutation CreateProduct(
        $name: String!, 
        $productId: String!, 
        $productType: ProductType!,
        $iconSymbol: String, 
        $iconColor: String, 
        $isinCode: String,
        $deliveryType: ProductDeliveryType, 
        $deliveryPeriod: ProductDeliveryPeriod, 
        $quantityUnit: ProductQuantityUnit, 
        $correlationId: String!
    ) {
        createProduct(
            name: $name, 
            productId: $productId, 
            productType: $productType,
            iconSymbol: $iconSymbol, 
            iconColor: $iconColor, 
            isinCode: $isinCode,
            deliveryType: $deliveryType, 
            deliveryPeriod: $deliveryPeriod, 
            quantityUnit: $quantityUnit, 
            correlationId: $correlationId
        ) {
            name
            productId
        }
    }
`;

export const ON_PRODUCT_CHANGED = gql`
    subscription onProductChanged {
        productChanged {
            correlationId
            action
            model {
                name
                productId
            }
        }
    }
`;

export const UPDATE_PRODUCT = gql`
    mutation UpdateProduct(
        $id: Int!,
        $name: String!, 
        $productId: String!, 
        $iconSymbol: String, 
        $iconColor: String, 
        $isinCode: String,
        $deliveryType: ProductDeliveryType, 
        $deliveryPeriod: ProductDeliveryPeriod, 
        $quantityUnit: ProductQuantityUnit, 
        $correlationId: String!
    ) {
        updateProduct(
            id: $id,
            name: $name, 
            productId: $productId, 
            iconSymbol: $iconSymbol, 
            iconColor: $iconColor, 
            isinCode: $isinCode,
            deliveryType: $deliveryType, 
            deliveryPeriod: $deliveryPeriod, 
            quantityUnit: $quantityUnit, 
            correlationId: $correlationId
        ) {
            name
            productId
        }
    }
`;

export const TOGGLE_PRODUCT_ACTIVATION = gql`
    mutation ToggleProductActivation(
        $id: Int!,
        $correlationId: String!
    ) {
        toggleProductActivation(
            id: $id,
            correlationId: $correlationId
        ) {
            name
            productId
            active
        }
    }
`;
